export function WhatIsStapel() {
  return (
    <section className="flex flex-col items-center justify-center w-full relative">
      <div className="absolute inset-0">
        <div className="absolute inset-0 -z-10 w-full bg-gradient-to-b from-background via-secondary to-secondary" />
      </div>
      <div className="container mx-auto px-6">
        <div className="w-full h-full relative">
          <div className="p-10 md:p-14">
            <div className="max-w-xl mx-auto flex flex-col items-center justify-center gap-2">
              <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-center text-balance text-[#111]">
                Was ist stapel.ai?
              </h2>
              <p className="text-muted-foreground text-center text-balance font-medium leading-relaxed">
                stapel.ai unterstützt Vergabestellen entlang des gesamten
                Vergabeprozesses: von der Erstellung rechtssicherer
                Leistungsbeschreibungen über die systematische Qualitätsprüfung
                Ihrer Vergabedokumente bis hin zur effizienteren Auswertung
                eingehender Angebote. Unsere KI erkennt typische Fehler, weist
                auf potenzielle Risiken hin und hilft Ihnen, Ihre Unterlagen
                strukturiert und nachvollziehbar aufzubereiten.
              </p>
            </div>
          </div>
          <div className="border-b w-full" />
        </div>
      </div>
    </section>
  );
}
